module.exports = __webpack_public_path__ + "img/dp_banner.e29a237.png";